import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];
  static values = {
    searchUrl: String,
    excludeId: Number
  };

  connect() {
    if (typeof $ === "undefined" || !$.fn || !$.fn.selectize) return;
    this.initSelectize();
  }

  disconnect() {
    if (this.selectize) this.selectize.destroy();
  }

  initSelectize() {
    const exclude = this.excludeIdValue;
    const url = this.searchUrlValue;

    $(this.inputTarget).selectize({
      valueField: "id",
      labelField: "public_id",
      searchField: ["public_id", "question_excerpt"],
      placeholder: this.inputTarget.placeholder,
      create: false,
      maxItems: null,
      plugins: ["remove_button"],
      preload: false,
      delimiter: ",",
      load: (query, callback) => {
        if (!query.length) return callback();
        $.ajax({
          url,
          type: "GET",
          dataType: "json",
          data: { q: query, exclude_id: exclude },
          error: () => callback(),
          success: (data) => callback(data || [])
        });
      },
      render: {
        option: (item, escape) => `
          <div>
            <strong>${escape(item.public_id)}</strong>
            <div class="text-muted small">${escape(item.question_excerpt)}</div>
          </div>`,
        item: (item, escape) => `<div>${escape(item.public_id)}</div>`
      }
    });

    this.selectize = this.inputTarget.selectize;
  }
}
